import { inject, Injectable } from "@angular/core";
import { Resolve, Router } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";

/**
 * Resolver posizionato solamente sulla rotta con `path:""`
 * unicamente utilizzata come redirect post login per keycloak.
 *
 * Il resolver si occupa solamente di:
 * - recuperare lo snapshot salvato prima del redirect **VERSO** keycloak
 * - redirectare l'utente verso l'ultima rotta visitata
 *
 * Se trova i dati dello snapshot fa il redirect e blocca la
 * renderizzazione del `BuyTicketlessModule` ritornando `EMPTY`.
 * Da li poi sara' il secondo Resolver (`PostLoginDataRestoreResolver`)
 * a ripopolare i service con i dati dello snapshot.
 *
 * Se non trova i dati dello snapshot procede normalmente con
 * la renderizzazione del `BuyTicketlessModule` che fara' in
 * autonomia la redirect verso una rotta `/buyTicketless/:codesr`
 * dalla logica del `BuyTicketlessComponent`.
 */
@Injectable({
  providedIn: 'root'
})
export class LoginCallbackResolver implements Resolve<boolean> {

  private router = inject(Router)

  resolve(): Observable<boolean>{

    const redirectDataString = localStorage.getItem('redirect');

    if (redirectDataString) {

      const redirectData = JSON.parse(redirectDataString);
      const targetPath = redirectData.lastPath;

      this.router.navigate([targetPath]);

      return EMPTY;
    }

    this.router.navigate(['/buyTicketless']);
    return of(true);
  }
}
